<template>
  <section id="home_invite">
    <div class="box flex-row" @click="$emit('invite')">
      <div class="flex-column col1">
        <BaseImage :src="inviteImage" alt="Invite Friends Icon" />
      </div>

      <div class="flex-column col2">
        <p class="heading">{{ $_translations.value.item_invite_title }}</p>

        <p class="text">{{ $_translations.value.item_invite_description }}</p>
      </div>

      <div class="flex-column col3">
        <i class="fas fa-chevron-right"></i>
      </div>
    </div>
  </section>
</template>

<script setup>
import BaseImage from '@/components/image/BaseImage.vue';
import { inviteImage } from '@/constants/image.js';

defineEmits(['invite']);
</script>
